import { Terminator } from "@opendaw/lib-std";
import { ParameterAdapterSet } from "../ParameterAdapterSet";
import { ModularAdapter } from "./modular";
export class AbstractModuleAdapter {
    #context;
    #box;
    #terminator;
    #attributes;
    #parameters;
    #selected = false;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#terminator = new Terminator();
        this.#attributes = box.attributes;
        this.#parameters = this.#terminator.own(new ParameterAdapterSet(context));
    }
    get inputs() {
        throw new Error("Method not implemented.");
    }
    get outputs() {
        throw new Error("Method not implemented.");
    }
    own(terminable) { return this.#terminator.own(terminable); }
    ownAll(...terminables) { this.#terminator.ownAll(...terminables); }
    onSelected() { this.#selected = true; }
    onDeselected() { this.#selected = false; }
    isSelected() { return this.#selected; }
    get box() { return this.#box; }
    get attributes() { return this.#attributes; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get parameters() { return this.#parameters; }
    get modular() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.attributes.collection.targetVertex.unwrap().box, ModularAdapter);
    }
    terminate() { this.#terminator.terminate(); }
}
